import ComponentBasePrototype from 'ComponentBasePrototype';
import $ from 'jquery';

export default class ContentCentralAccordion extends ComponentBasePrototype {
  build() {
    this.openedAccordionClass = 'content-article__accordion--opened';

    this.scrollToAccordion();
    this.toggleAccordion();
    this.adjustAnchorPosition();
    this.hashChange();

    return true;
  }

  hashChange() {
    $(window).on('hashchange', () => {
      const shouldOpen = this.hashMatchesAccordionName();
  
      if (shouldOpen) {
        // We don't explicitly scroll to the accordion here because the browser will be instascrolling to the accordion on it's own.
        this.openAccordion();
      }
    });
  }
  
  adjustAnchorPosition() {
    const anchor = this.node.find('.content-article__accordion-anchor');
    const offset = this.getNavigationOffset();
    anchor.css('top', `-${offset}px`);
  }

  hashMatchesAccordionName() {
    const accordionHash = window.location.hash.substr(1);
    return accordionHash === this.data.snippetName;
  }

  scrollToAccordion() {
    const shouldScroll = this.hashMatchesAccordionName();

    if (shouldScroll) {
      const offset = this.getNavigationOffset();

      $('html, body').animate({
        scrollTop: (this.node.offset().top) - offset,
      }, 300);

      this.openAccordion();
    }
  }

  getNavigationOffset() {
    // We're not interested in the top bar height because most likely it will not be visible when scrolled to an accordion.
    const mainNavigationHeight = $('.cms-navigation-2019__main').height() || 0;
    const subNavigationHeight = $('.sub-nav').height() || 0;
    const offset = mainNavigationHeight + subNavigationHeight + 20;
    return offset;
  }
  
  openAccordion() {
    const accordionDescription = this.node.find('.content-article__accordion-description');
    accordionDescription.css({
      'visibility': 'visible',
      'opacity': '1',
      'pointer-events': 'auto'
    });

    this.node.addClass(this.openedAccordionClass);
    this.node.find('.content-article__accordion-heading').attr('aria-expanded', 'true');
    this.node.find('svg').addClass('rotated');
    this.removeCustomStyles(this.getelementHeading(this.node));
    const previousAccordion = this.getPreviousAccordion();

    if (previousAccordion) {
      const previousAccordionIsOpen = previousAccordion.classList.contains(this.openedAccordionClass);

      if (!previousAccordionIsOpen) {
        this.removeBorder(this.getelementHeading(previousAccordion));
      }
    }

    history.replaceState(null, null, `#${this.data.snippetName}`);
  }

  closeAccordion() {
    const accordionDescription = this.node.find('.content-article__accordion-description');
    accordionDescription.css({
      'visibility': 'hidden',
      'opacity': '0',
      'pointer-events': 'none'
    });

    this.node.removeClass(this.openedAccordionClass);
    this.node.find('.content-article__accordion-heading').attr('aria-expanded', 'false');
    this.node.find('svg').removeClass('rotated');
    this.removeCustomStyles(this.getelementHeading(this.node));
    const previousAccordion = this.getPreviousAccordion();
    const nextAccordion = this.getNextAccordion();

    if (nextAccordion) {
      const nextAccordionIsOpen = nextAccordion.classList.contains(this.openedAccordionClass);

      if (nextAccordionIsOpen) {
        this.removeBorder(this.getelementHeading(this.node));
      } else {
        this.removeCustomStyles(this.getelementHeading(previousAccordion));
      }
    }

    if (previousAccordion) {
      const previousAccordionIsOpen = previousAccordion.classList.contains(this.openedAccordionClass);

      if (!previousAccordionIsOpen) {
        this.removeCustomStyles(this.getelementHeading(previousAccordion));
      }
    }

    history.replaceState(null, null, location.pathname);
  }

  toggleAccordion() {
  const accordionHeading = this.node.find('.content-article__accordion-heading');
  
  accordionHeading.on('click', () => {
    this.node.toggleClass(this.openedAccordionClass);

    if (this.node.hasClass(this.openedAccordionClass)) {
      this.openAccordion();
    } else {
      this.closeAccordion();
    }
  });
}

  removeBorder(element) {
    $(element).css('border-bottom', 'none');
  }

  removeCustomStyles(element) {
    $(element).removeAttr('style');
  }

  getelementHeading(element) {
    return $(element).children()[0];
  }

  getPreviousAccordion() {
    const previousElement = this.node.prev()[0];
    const isPreviousElementAccordion = this.isElementAnAccordion(previousElement);

    return isPreviousElementAccordion ? previousElement : false;
  }

  getNextAccordion() {
    const nextElement = this.node.next()[0];
    const isNextElementAccordion = this.isElementAnAccordion(nextElement);

    return isNextElementAccordion ? nextElement : false;
  }

  isElementAnAccordion(element) {
    if (element) {
      return element.classList.contains('content-article__accordion');
    }

    return false;
  }
}
